import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import React from 'react'

export default function ConfirmDialog({open, setOpen, handleDelete, item, message}) {
    return (
        <>
            <Dialog aria-labelledby='dialog-title' onClose={() => setOpen(false)} open={open}>
                <DialogTitle id='dialog-title'>
                    {message}
                </DialogTitle>
                <DialogContent>
                    {/* <DialogContentText style={{color: "red"}}>This action is irreversible!</DialogContentText> */}
                </DialogContent>
                <DialogActions>
                    <Button
                        color="secondary"
                        onClick={() => setOpen(false)}
                        variant="contained"
                    >Cancel</Button>
                    <Button
                        color="primary"
                        onClick={() => handleDelete(item._id ? item._id : item.id)}
                        variant="contained"
                    >Yes</Button>
                </DialogActions>
            </Dialog>
        </>
    )
}